module.exports = __webpack_public_path__ + "static/media/mobile-lobby.65f79779.jpg";